type StateShape = {
  currentPoint: number;
};

export const usePointStore = defineStore("pointStore", {
  state: (): StateShape => {
    const currentPoint: Ref<number> = ref<number>(0);

    return {
      currentPoint: currentPoint.value,
    };
  },
  actions: {
    increasePoints(increaseCount: number) {
      this.currentPoint = this.currentPoint + increaseCount;
    },
    decreasePoints(decreaseCount: number) {
      this.currentPoint = this.currentPoint - decreaseCount;
    },
    updatePoints(current: number) {
      this.currentPoint = current;
    },
  },
});
